import { findElementAsync } from '@/js/lib/util'

const handleFirstTab = (e) => {
  if (e.keyCode === 9) {
    document.body.classList.add('user-is-tabbing')

    window.removeEventListener('keydown', handleFirstTab)
    window.addEventListener('mousedown', handleMouseDownOnce)
  }
}

const handleMouseDownOnce = () => {
  document.body.classList.remove('user-is-tabbing')

  window.removeEventListener('mousedown', handleMouseDownOnce)
  window.addEventListener('keydown', handleFirstTab)
}

window.addEventListener('keydown', handleFirstTab)

const handleFootNoteNavigate = () => {
  const footerNoteLinks = document.querySelectorAll('a[href="#footer-footnote"]')
  const footerNoteElm = document.querySelector('#footer-footnote')

  if (footerNoteLinks.length > 0) {
    footerNoteLinks.forEach(link => {
      link.addEventListener('click', () => footerNoteElm.focus())
    })
  }
}

window.addEventListener('DOMContentLoaded', handleFootNoteNavigate)

const waitForOneTrust = () => {
  hasOneTrustLoaded()
  let attempts = 0
  const interval = setInterval(function () {
    if (hasOneTrustLoaded() || attempts > 100) {
      clearInterval(interval)
      replaceOneTrustBanner()
    }
    attempts++
  }, 100)
}

const hasOneTrustLoaded = () => {
  if (window.OnTrust) {
    return true
  }
  return false
}

const replaceOneTrustBanner = () => {
  if (document.querySelector('#onetrust-consent-sdk') && document.querySelector('#skip_to_content')) {
    const destination = document.querySelector('#skip_to_content')
    const cookiebanner = document.querySelector('#onetrust-consent-sdk')
    destination.after(cookiebanner)
  }
}

const updateYotpoLink = async () => {
  const reviewLink = await findElementAsync('.product-form .yotpo-sr-bottom-line-summary')
  if (!reviewLink) return
  reviewLink.href = '#yotpo-reviews-main-widget'
}

const addWhereToBuyIframeTitle = async () => {
  const iframe = await findElementAsync('.drb_embed iframe')

  if (!iframe) return
  iframe.setAttribute('title', 'Where to Buy In-Store and Online | Store Locator for CPG brands')
}

(function () {
  waitForOneTrust()
  updateYotpoLink()
  addWhereToBuyIframeTitle()
  window.addEventListener('yotpo-refreshed', () => updateYotpoLink())
})()